const tutorialGameStudentsData = {
  game: {
    id: "618b90a18457e8832c81a5b9",
    groups: [],
    players: [
      {
        group: null,
        id: "6197b0801e7bc515de1bf63d",
        stats: {
          nrOfSubmissions: 24,
          nrOfValidations: 49,
          __typename: "PlayerStats",
        },
        user: {
          id: "0b59794b-e01a-409c-a319-81b04ef0eb7b",
          firstName: "Ava",
          lastName: "Smith",
          __typename: "User",
        },
        learningPath: [
          {
            progress: 1,
            __typename: "ChallengeStatus",
          },
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
        ],
        __typename: "Player",
      },
      {
        group: null,
        id: "6197b0811e7bc5ba0c1bf640",
        stats: {
          nrOfSubmissions: 5,
          nrOfValidations: 8,
          __typename: "PlayerStats",
        },
        user: {
          id: "09d21b2b-6c70-4ce1-b2b3-a3a809cb665b",
          firstName: "Ethan",
          lastName: "Johnson",
          __typename: "User",
        },
        learningPath: [
          {
            progress: 1,
            __typename: "ChallengeStatus",
          },
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
        ],
        __typename: "Player",
      },
      {
        group: null,
        id: "6197b0b11e7bc5a1681bf646",
        stats: {
          nrOfSubmissions: 30,
          nrOfValidations: 52,
          __typename: "PlayerStats",
        },
        user: {
          id: "42675cdf-6816-4114-944a-61f2128adc22",
          firstName: "Isabella",
          lastName: "Garcia",
          __typename: "User",
        },
        learningPath: [
          {
            progress: 0.3333333333333333,
            __typename: "ChallengeStatus",
          },
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
        ],
        __typename: "Player",
      },
      {
        group: null,
        id: "6197b0f61e7bc52f861bf64b",
        stats: {
          nrOfSubmissions: 12,
          nrOfValidations: 51,
          __typename: "PlayerStats",
        },
        user: {
          id: "1059ea86-c873-49fc-8a3e-103779017e02",
          firstName: "Lucas",
          lastName: "Nguyen",
          __typename: "User",
        },
        learningPath: [
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
        ],
        __typename: "Player",
      },
      {
        group: null,
        id: "6197b11f1e7bc523541bf650",
        stats: {
          nrOfSubmissions: 26,
          nrOfValidations: 42,
          __typename: "PlayerStats",
        },
        user: {
          id: "7fb2776c-4c71-478c-83e2-e59380c9d314",
          firstName: "Sophia",
          lastName: "Lee",
          __typename: "User",
        },
        learningPath: [
          {
            progress: 1,
            __typename: "ChallengeStatus",
          },
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
        ],
        __typename: "Player",
      },
      {
        group: null,
        id: "6197b1231e7bc56d7e1bf653",
        stats: {
          nrOfSubmissions: 4,
          nrOfValidations: 24,
          __typename: "PlayerStats",
        },
        user: {
          id: "1204fc09-a47f-4fa8-8383-59f04f5ad64f",
          firstName: "Jackson",
          lastName: "Patel",
          __typename: "User",
        },
        learningPath: [
          {
            progress: 1,
            __typename: "ChallengeStatus",
          },
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
        ],
        __typename: "Player",
      },
      {
        group: null,
        id: "6197b1571e7bc59dbd1bf658",
        stats: {
          nrOfSubmissions: 11,
          nrOfValidations: 129,
          __typename: "PlayerStats",
        },
        user: {
          id: "445e3e4c-857c-4439-bc2e-c933cc3553b0",
          firstName: "Harper",
          lastName: "Brown",
          __typename: "User",
        },
        learningPath: [
          {
            progress: 1,
            __typename: "ChallengeStatus",
          },
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
        ],
        __typename: "Player",
      },
      {
        group: null,
        id: "6197b1681e7bc558831bf65b",
        stats: {
          nrOfSubmissions: 0,
          nrOfValidations: 59,
          __typename: "PlayerStats",
        },
        user: {
          id: "11c91586-e71e-442d-84d0-6edceb751218",
          firstName: "Noah",
          lastName: "Davis",
          __typename: "User",
        },
        learningPath: [
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
        ],
        __typename: "Player",
      },
      {
        group: null,
        id: "6197b1801e7bc55e701bf65e",
        stats: {
          nrOfSubmissions: 7,
          nrOfValidations: 75,
          __typename: "PlayerStats",
        },
        user: {
          id: "055b6dda-1323-4840-8998-0ca2d82bdcd2",
          firstName: "Mia",
          lastName: "Johnson",
          __typename: "User",
        },
        learningPath: [
          {
            progress: 1,
            __typename: "ChallengeStatus",
          },
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
        ],
        __typename: "Player",
      },
      {
        group: null,
        id: "6197b1f31e7bc54e311bf675",
        stats: {
          nrOfSubmissions: 17,
          nrOfValidations: 55,
          __typename: "PlayerStats",
        },
        user: {
          id: "7bf2944d-59ca-4db7-9c96-ca6273a1a4e5",
          firstName: "Alexander",
          lastName: "Wilson",
          __typename: "User",
        },
        learningPath: [
          {
            progress: 0.3333333333333333,
            __typename: "ChallengeStatus",
          },
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
        ],
        __typename: "Player",
      },
      {
        group: null,
        id: "6197b1fb1e7bc556671bf678",
        stats: {
          nrOfSubmissions: 14,
          nrOfValidations: 22,
          __typename: "PlayerStats",
        },
        user: {
          id: "74373219-87a2-4aff-aefb-2708770747f2",
          firstName: "Olivia",
          lastName: "Brown",
          __typename: "User",
        },
        learningPath: [
          {
            progress: 1,
            __typename: "ChallengeStatus",
          },
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
        ],
        __typename: "Player",
      },
      {
        group: null,
        id: "6197b2221e7bc536851bf684",
        stats: {
          nrOfSubmissions: 5,
          nrOfValidations: 38,
          __typename: "PlayerStats",
        },
        user: {
          id: "d7f970ed-8f89-491c-bbb3-c5e1f24039cf",
          firstName: "Ethan",
          lastName: "Reed",
          __typename: "User",
        },
        learningPath: [
          {
            progress: 1,
            __typename: "ChallengeStatus",
          },
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
        ],
        __typename: "Player",
      },
      {
        group: null,
        id: "6197b2231e7bc5e08b1bf687",
        stats: {
          nrOfSubmissions: 3,
          nrOfValidations: 39,
          __typename: "PlayerStats",
        },
        user: {
          id: "2ac0ee1f-b278-43fe-84fb-eaf3576e7bdd",
          firstName: "Lila",
          lastName: "Chen",
          __typename: "User",
        },
        learningPath: [
          {
            progress: 0.3333333333333333,
            __typename: "ChallengeStatus",
          },
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
        ],
        __typename: "Player",
      },
      {
        group: null,
        id: "6197b2241e7bc542d51bf68a",
        stats: {
          nrOfSubmissions: 1,
          nrOfValidations: 26,
          __typename: "PlayerStats",
        },
        user: {
          id: "39d336f8-c164-4c34-ba65-93eacfdd1b05",
          firstName: "Ava",
          lastName: "Singh",
          __typename: "User",
        },
        learningPath: [
          {
            progress: 0.3333333333333333,
            __typename: "ChallengeStatus",
          },
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
        ],
        __typename: "Player",
      },
      // {
      //   group: null,
      //   id: "6197b2331e7bc5a4fa1bf68d",
      //   stats: {
      //     nrOfSubmissions: 7,
      //     nrOfValidations: 29,
      //     __typename: "PlayerStats",
      //   },
      //   user: {
      //     id: "c7022528-7bdd-45d3-8579-32d73892e394",
      //     firstName: "Mason",
      //     lastName: "Gupta",
      //     __typename: "User",
      //   },
      //   learningPath: [
      //     {
      //       progress: 1,
      //       __typename: "ChallengeStatus",
      //     },
      //     {
      //       progress: 1,
      //       __typename: "ChallengeStatus",
      //     },
      //   ],
      //   __typename: "Player",
      // },
      {
        group: null,
        id: "6197b2701e7bc523111bf693",
        stats: {
          nrOfSubmissions: 11,
          nrOfValidations: 33,
          __typename: "PlayerStats",
        },
        user: {
          id: "9ffbe83b-395c-4377-9864-92705018fa13",
          firstName: "Lily",
          lastName: "Davis",
          __typename: "User",
        },
        learningPath: [
          {
            progress: 0.3333333333333333,
            __typename: "ChallengeStatus",
          },
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
        ],
        __typename: "Player",
      },
      {
        group: null,
        id: "6197b2721e7bc5551b1bf697",
        stats: {
          nrOfSubmissions: 22,
          nrOfValidations: 33,
          __typename: "PlayerStats",
        },
        user: {
          id: "b88f2b5f-4b24-42bc-a89b-0e7f4c85c450",
          firstName: "Ana",
          lastName: "Kim",
          __typename: "User",
        },
        learningPath: [
          {
            progress: 1,
            __typename: "ChallengeStatus",
          },
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
        ],
        __typename: "Player",
      },
      {
        group: null,
        id: "6197b2d71e7bc564c31bf6b0",
        stats: {
          nrOfSubmissions: 7,
          nrOfValidations: 18,
          __typename: "PlayerStats",
        },
        user: {
          id: "2467755a-87fa-45fa-8453-d753b66e4b97",
          firstName: "Isaac",
          lastName: "Chen",
          __typename: "User",
        },
        learningPath: [
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
        ],
        __typename: "Player",
      },
      {
        group: null,
        id: "6197ba5f1e7bc5a90b1bf90a",
        stats: {
          nrOfSubmissions: 1,
          nrOfValidations: 3,
          __typename: "PlayerStats",
        },
        user: {
          id: "9817b7b9-e809-4de3-aeaa-208be3e1a875",
          firstName: "Alexandre",
          lastName: "Rodriguez",
          __typename: "User",
        },
        learningPath: [
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
        ],
        __typename: "Player",
      },
      {
        group: null,
        id: "6197ba7e1e7bc54c241bf919",
        stats: {
          nrOfSubmissions: 1,
          nrOfValidations: 1,
          __typename: "PlayerStats",
        },
        user: {
          id: "35e44a8c-5408-41f6-800c-c14aa025500e",
          firstName: "Grace",
          lastName: "Kim",
          __typename: "User",
        },
        learningPath: [
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
        ],
        __typename: "Player",
      },
      {
        group: null,
        id: "6197baa41e7bc516c11bf92a",
        stats: {
          nrOfSubmissions: 13,
          nrOfValidations: 14,
          __typename: "PlayerStats",
        },
        user: {
          id: "e7fec798-de04-4d28-80ab-49538e93ef9c",
          firstName: "Mia",
          lastName: "Martinez",
          __typename: "User",
        },
        learningPath: [
          {
            progress: 1,
            __typename: "ChallengeStatus",
          },
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
        ],
        __typename: "Player",
      },
      {
        group: null,
        id: "6197bab21e7bc512d51bf930",
        stats: {
          nrOfSubmissions: 8,
          nrOfValidations: 38,
          __typename: "PlayerStats",
        },
        user: {
          id: "d18841fe-4071-4747-8856-b2b74339613f",
          firstName: "Harper",
          lastName: "Wong",
          __typename: "User",
        },
        learningPath: [
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
        ],
        __typename: "Player",
      },
      {
        group: null,
        id: "6197bb391e7bc50e871bf970",
        stats: {
          nrOfSubmissions: 1,
          nrOfValidations: 1,
          __typename: "PlayerStats",
        },
        user: {
          id: "b1b25fa4-cedd-4c1e-96e8-f496117c16ee",
          firstName: "Fernando",
          lastName: "Santos",
          __typename: "User",
        },
        learningPath: [
          {
            progress: 0.3333333333333333,
            __typename: "ChallengeStatus",
          },
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
        ],
        __typename: "Player",
      },
      {
        group: null,
        id: "6197bb5c1e7bc577b71bf982",
        stats: {
          nrOfSubmissions: 0,
          nrOfValidations: 0,
          __typename: "PlayerStats",
        },
        user: {
          id: "be97a91e-6b1a-44a1-a1c6-ab1d9466737f",
          firstName: "Edwin",
          lastName: "Williams",
          __typename: "User",
        },
        learningPath: [
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
        ],
        __typename: "Player",
      },
      {
        group: null,
        id: "6197be891e7bc525781bfa72",
        stats: {
          nrOfSubmissions: 5,
          nrOfValidations: 13,
          __typename: "PlayerStats",
        },
        user: {
          id: "f3124287-9db1-46e5-bd20-c628fd714637",
          firstName: "Robert",
          lastName: "Garcia",
          __typename: "User",
        },
        learningPath: [
          {
            progress: 1,
            __typename: "ChallengeStatus",
          },
          {
            progress: 1,
            __typename: "ChallengeStatus",
          },
        ],
        __typename: "Player",
      },
      {
        group: null,
        id: "622289d00a67a3fe0c1daf07",
        stats: {
          nrOfSubmissions: 0,
          nrOfValidations: 0,
          __typename: "PlayerStats",
        },
        user: {
          id: "92f1b228-e255-4ca2-8df7-295ecae12be2",
          firstName: "Kim",
          lastName: "Nguyen",
          __typename: "User",
        },
        learningPath: [
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
        ],
        __typename: "Player",
      },
      {
        group: null,
        id: "624fef1789397ab5e95f2531",
        stats: {
          nrOfSubmissions: 0,
          nrOfValidations: 0,
          __typename: "PlayerStats",
        },
        user: {
          id: "b7cfdd06-ae71-4071-a8d2-2226dbeaeb13",
          firstName: "Marcin",
          lastName: "Kowalski",
          __typename: "User",
        },
        learningPath: [
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
        ],
        __typename: "Player",
      },
      {
        group: null,
        id: "6278e02b384d74ad90cb3ebd",
        stats: {
          nrOfSubmissions: 1,
          nrOfValidations: 0,
          __typename: "PlayerStats",
        },
        user: {
          id: "39802822-eae2-40e4-9d18-4eb8502d285a",
          firstName: "Denis",
          lastName: "Alekseev",
          __typename: "User",
        },
        learningPath: [
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
        ],
        __typename: "Player",
      },
      {
        group: null,
        id: "627a0c648773d64df1421bd4",
        stats: {
          nrOfSubmissions: 0,
          nrOfValidations: 0,
          __typename: "PlayerStats",
        },
        user: {
          id: "8a6c7b74-b515-4117-9516-dd5a86789426",
          firstName: "Andrew",
          lastName: "Aguilar",
          __typename: "User",
        },
        learningPath: [
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
        ],
        __typename: "Player",
      },
      {
        group: null,
        id: "627c00de93b4a311e28e155f",
        stats: {
          nrOfSubmissions: 0,
          nrOfValidations: 0,
          __typename: "PlayerStats",
        },
        user: {
          id: "1b335cd6-b6fb-44c9-bddd-4acf549587b2",
          firstName: "Kendall",
          lastName: "Harris",
          __typename: "User",
        },
        learningPath: [
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
        ],
        __typename: "Player",
      },
      {
        group: null,
        id: "62839f19f746a10bac17eef7",
        stats: {
          nrOfSubmissions: 0,
          nrOfValidations: 0,
          __typename: "PlayerStats",
        },
        user: {
          id: "df80a417-2847-4763-960a-b469be48001b",
          firstName: "Urszula",
          lastName: "Zielińska",
          __typename: "User",
        },
        learningPath: [
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
        ],
        __typename: "Player",
      },
      {
        group: null,
        id: "634933c10dc77ac0233392af",
        stats: {
          nrOfSubmissions: 0,
          nrOfValidations: 0,
          __typename: "PlayerStats",
        },
        user: {
          id: "4b719670-8c9b-47bf-96bb-d2d99ddd5e46",
          firstName: "Oskar",
          lastName: "Berggren",
          __typename: "User",
        },
        learningPath: [
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
          {
            progress: 0,
            __typename: "ChallengeStatus",
          },
        ],
        __typename: "Player",
      },
    ],
    __typename: "Game",
  },
};

export default tutorialGameStudentsData;
